module.exports = __webpack_public_path__ + "static/media/idlepage-casehistories.d522d1a0.svg";